import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { twMerge } from "@/lib/twMerge";

// Links from wherever a map mentions a capability or standard to its page, so every name on
// a map page goes somewhere — consistent with the tool and standard links elsewhere.

/** A capability id (as maps write it, e.g. `maintain-policy`) linking to `/registry/<id>`. */
export function CapabilityLink({ id, className }: { id: string; className?: string }) {
  return (
    <Link
      to={`/registry/${encodeURIComponent(id)}`}
      className={twMerge("font-mono text-xs text-accent underline", className)}
    >
      {id}
    </Link>
  );
}

/** Several capability ids, joined by `separator` (", " or " ↔ "), each a link. */
export function CapabilityLinks({ ids, separator = ", " }: { ids: string[]; separator?: string }) {
  return (
    <>
      {ids.map((id, i) => (
        <span key={id}>
          {i > 0 && separator}
          <CapabilityLink id={id} />
        </span>
      ))}
    </>
  );
}

/** A standard linking to `/standards/<id>`, showing its name (`children`) or else its id. */
export function StandardLink({ id, children, className }: { id: string; children?: ReactNode; className?: string }) {
  return (
    <Link to={`/standards/${encodeURIComponent(id)}`} className={twMerge("text-accent underline", className)}>
      {children ?? id}
    </Link>
  );
}
